var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ContentCollectionHorizontal } from "contentCollection";
import { Env, config } from "core/utils";
import * as Option from "fp-ts/lib/Option";
import qs from "qs";
import React from "react";
import { useLocation } from "react-router-dom";
function isCompatible(video) {
    return video.relatedVideos !== null && video.relatedVideos.length > 0;
}
export var block = function (data) {
    var location = useLocation();
    if (!isCompatible(data))
        return Option.none;
    var relatedPosition = Number(qs.parse(location.search, {
        ignoreQueryPrefix: true,
    }).relatedPos) || 0;
    var reorderedVids = [];
    var vids = data.relatedVideos.map(function (vid, index) {
        // Videos that come after the current video should get a higher index
        // because the current video is left out the list
        var position = relatedPosition <= index ? index + 1 : index;
        return __assign(__assign({}, vid), { slug: "".concat(vid.slug, "?relatedPos=").concat(position) });
    });
    if (Env.isTouch && relatedPosition) {
        var beforeCurrent = vids.slice(0, relatedPosition);
        var afterCurrent = vids.slice(relatedPosition);
        reorderedVids = __spreadArray(__spreadArray([], afterCurrent, true), beforeCurrent, true);
    }
    else {
        reorderedVids = vids;
    }
    return Option.some({
        key: "videoRelatedVideos",
        View: function () {
            var _a, _b;
            return (React.createElement(ContentCollectionHorizontal, { componentId: "contentCollectionRelatedVideos", listName: config.tracking.listNames.relatedVideos, title: "Gerelateerde video's", items: reorderedVids, currentPos: relatedPosition, trackingEnabled: !data.fetchingData, callToAction: data.program ? { url: (_a = data.program) === null || _a === void 0 ? void 0 : _a.slug, title: "Ga naar ".concat((_b = data.program) === null || _b === void 0 ? void 0 : _b.title) } : undefined }));
        },
    });
};
